import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { USER_ROLES } from '@shared/index';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-booking-payment-status-popup',
  templateUrl: './booking-payment-status-popup.component.html',
  styleUrls: ['./booking-payment-status-popup.component.scss']
})
export class BookingPaymentStatusPopupComponent implements OnInit{
  bodyText = '';
  extraError: string;
  role : string;
  companyId: string;
  userRoles = USER_ROLES;
  constructor(private readonly router: Router, public readonly ref: DynamicDialogRef, public readonly config: DynamicDialogConfig, private readonly encryptStorage: EncryptionStorageService) { }

  ngOnInit(): void {
    this.bodyText = this.config.data.bodyText;
    this.extraError = this.config.data.extraError;
    this.role = this.encryptStorage.getItem('roleName');
    this.companyId = this.encryptStorage.getItem('companyId');

  }

  continue(): void {
    const token = this.encryptStorage.getItem('token');
    this.ref.close();
    if (token) {
         const roleRoutes: { [key: string]: string } = {
      [this.userRoles.SUPER_ADMIN]: `/super-admin/bookings/${this.companyId}?tab=0`,
      [this.userRoles.DRIVER]: '/driver/bookings?tab=0',
      [this.userRoles.GROUP_USER]: '/group-operator/booking-list?tab=0',
      };
      const baseUrl = roleRoutes[this.role] || 'manager/bookings?tab=0';
      this.router.navigateByUrl(baseUrl);
    }else {
      this.router.navigateByUrl('/login');
    }
  }
}
